import { render, staticRenderFns } from "./settingsDialog.vue?vue&type=template&id=6763ffb0&scoped=true"
import script from "./settingsDialog.vue?vue&type=script&lang=js"
export * from "./settingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6763ffb0",
  null
  
)

export default component.exports